import styled from 'styled-components';

// TODO Need to use breakaway sizes but using old common sass sizes for now
export const TABLET_PORTRAIT_UP = '@media (min-width: 600px)';

export const LogoContainer = styled.div`
    display: flex;
    margin-right: 16px;
    
    ${TABLET_PORTRAIT_UP} {
        margin-left: 16px;
    }
    
    a {
        display: flex;
        align-items: center;
    }
`;

export const Logo = styled.img`
    height: 48px;
`;
